import { reactive, ref } from 'vue'
import { usePoliticalActions as todaPoliticalActionToda } from '@/services/politicalActionToda/usePoliticalActions'
import { usePoliticalActions as defaltPoliticalActionToda } from '@/services/politicalAction/usePoliticalActions'
import { useMemoryItemForm as todaMemoryItem } from '@/services/politicalActionToda/useMemoryItemForm'
import { useMemoryItemForm as defaltMemoryItem } from '@/services/politicalAction/useMemoryItemForm'
import { useReceipts as osakaReceipts } from '@/services/receiptsOsaka/useReceipts'
import { useReceipts as yokohamaReceipts } from '@/services/receiptsYokohama/useReceipts'
import { useReceipts as todaReceipts } from '@/services/receiptsToda/useReceipts'
import { useReceipts as defaltReceipts } from '@/services/receipt/useReceipts'

const imgUploader = reactive({
  error: '',
  files: [],
  dropped: 0,
  imgs: [],
})
const isImgEditorOpen = ref(false)
const isImgZoomerOpen = ref(false)
const isImgWarpOpen = ref(false)
const imageIndex = ref(null)
const expIndex = ref(null)

export const useImgUploader = () => {
  const openImgEditor = index => {
    imageIndex.value = index
    isImgEditorOpen.value = true
  }

  const closeImgEditor = () => {
    isImgEditorOpen.value = false
  }

  const openImgZoomer = (index, expenseIndex) => {
    console.log('index :>> ', index)
    console.log('index :>> ', expenseIndex)
    imageIndex.value = index
    expIndex.value = expenseIndex
    isImgZoomerOpen.value = true
  }

  const closeImgZoomer = () => {
    isImgZoomerOpen.value = false
  }

  const openImgWarp = index => {
    imageIndex.value = index
    isImgWarpOpen.value = true
  }

  const closeImgWarp = () => {
    isImgWarpOpen.value = false
  }

  const putTrimImage = (src, index, type) => {
    if (src) {
      imgUploader.imgs[index] = src
      const addItem = {
        normalImage: src,
        blackImage: null,
      }
      // 環境変数を見て取得するcurrentPoliticalActionを変える。
      const areaName = process.env.VUE_APP_LOCATION
      if (type === 'request') {
        if (areaName === 'TODA') {
          const { currentPoliticalAction } = todaPoliticalActionToda()
          currentPoliticalAction.application.images[index] = addItem
        } else {
          const { currentPoliticalAction } = defaltPoliticalActionToda()
          currentPoliticalAction.application.images[index] = addItem
        }
      } else if (type === 'result') {
        if (areaName === 'TODA') {
          const { currentPoliticalAction } = todaPoliticalActionToda()
          currentPoliticalAction.report.images[index] = addItem
        } else {
          const { currentPoliticalAction } = defaltPoliticalActionToda()
          currentPoliticalAction.report.images[index] = addItem
        }
      } else if (type === 'memory') {
        if (areaName === 'TODA') {
          const { images } = todaMemoryItem()
          images.value[index] = addItem
        } else {
          const { images } = defaltMemoryItem()
          images.value[index] = addItem
        }
      } else if (type === 'receipt') {
        // 環境変数を見て取得するcurrentReceiptを変える。
        if (areaName === 'OSAKA') {
          const { currentReceipt } = osakaReceipts()
          currentReceipt.files[index] = addItem
        } else if (areaName === 'YOKOHAMA') {
          const { currentReceipt } = yokohamaReceipts()
          currentReceipt.files[index] = addItem
        } else if (areaName === 'TODA') {
          const { currentReceipt } = todaReceipts()
          currentReceipt.files[index] = addItem
        } else {
          const { currentReceipt } = defaltReceipts()
          currentReceipt.files[index] = addItem
        }
      } else {
        return
      }
    }
  }
  return {
    imgUploader,
    isImgEditorOpen,
    isImgZoomerOpen,
    isImgWarpOpen,
    imageIndex,
    expIndex,
    openImgEditor,
    closeImgEditor,
    openImgZoomer,
    closeImgZoomer,
    openImgWarp,
    closeImgWarp,
    putTrimImage,
  }
}
